try {
    window.moment = require("moment");
    // moment.locale('fr');

    window.Swal = require("sweetalert2");
} catch (e) {
    /* empty */
}
